/** 공개 사이트 페이지 본문 문구 — ko/landingPages.ts 와 같은 키(정본은 ko). */
const landingPages = {
  news: {
    eyebrow: "Press",
    title: "Press",
    count: "Total {{n}}",
    listLabel: "Articles",
    readMore: "Read article",
    openLabel: "{{title}} — read article",
    back: "Back to list",
    original: "View original",
    empty: "No articles yet.",
    imageUnavailable: "Image unavailable",
    translatedFrom: {
      ja: "Translated into Korean from the Japanese original.",
    },
    related: {
      title: "See also",
      platform: {
        alt: "The DroneSquare app icon tile floating over orthomosaic, drawing and 3D layer boards",
        kicker: "Service platform",
        title: "Drone-based infrastructure management platform",
        text: "Inspect and record drone-captured sites in 2D and 3D.",
      },
      releases: {
        alt: "A ringing gold notification bell with a badge showing 3, above a DroneSquare app notification card",
        kicker: "What's new",
        title: "The latest from DroneSquare",
        text: "See newly added features with demo videos.",
      },
    },
  },
  plan: {
    title: "DroneSquare service plans",
    lead: "Monitor your sites and achieve optimal maintenance<br/>with accurate data analysis from DroneSquare.",
    plansLabel: "Plans",
    standard: {
      name: "Standard Plan",
      description:
        "For analyzing and managing<br/><b>small-scale target sites</b>",
      features: [
        "Monthly subscription",
        "3,000 drone images / drone project setup",
        "Data processing twice a month",
      ],
    },
    advanced: {
      name: "Advanced Plan",
      description:
        "For analyzing and managing<br/><b>large-scale target sites</b>",
      features: [
        "Annual subscription with\nflexible usage options by agreement",
        "3,000+ drone images / drone project setup",
      ],
    },
    ask: "Contact us",
    compare: {
      title: "Compare at a glance",
      item: "Item",
      rows: [
        {
          label: "Target",
          standard: "Small-scale sites",
          advanced: "Large-scale sites",
        },
        {
          label: "Subscription",
          standard: "Monthly",
          advanced: "Annual",
        },
        {
          label: "Drone project setup",
          standard: "3,000 drone images",
          advanced: "3,000+ drone images",
        },
        {
          label: "Data processing",
          standard: "Twice a month",
          advanced: "Flexible by agreement",
        },
      ],
    },
    related: {
      title: "See also",
      platform: {
        alt: "The DroneSquare app icon tile floating over orthomosaic, drawing and 3D layer boards",
        kicker: "Platform",
        title: "Drone-based infrastructure management platform",
        text: "2D·3D·4D, surveying and sections, every data layer and site record on one screen.",
      },
      survey: {
        alt: "A drone flying over water",
        kicker: "Drone survey & spatial data processing",
        title: "Leave everything from capture to the platform to us",
        text: "Drone operation experts handle everything from flight approval to the platform.",
      },
    },
    closing: {
      eyebrow: "DroneSquare 1:1 inquiry",
      title: "Let's find the right plan<br/>for your site together",
    },
  },
  inquiry: {
    eyebrow: "1:1 inquiry",
    title: "DroneSquare 1:1 inquiry",
    copy: "Smart infrastructure asset<br/><em>management and analysis with DroneSquare</em>",
    photoAlt: "A camera drone flying over a site",
    chatTitle: "DroneSquare 1:1 chat",
    chatFallback: "This browser cannot show the chat window.",
    chatLoading: "Opening the chat window",
    chatFailedTitle: "We couldn't open the chat window",
    chatFailedText: "Try again in a moment, or call our main line.",
    chatRetry: "Try again",
    chatCall: "Call {{tel}}",
    chatOpen: "Chat with us",
    chatClose: "Close",
    moreTitle: "Before you ask",
    manual: {
      alt: "The DroneSquare app icon tile next to a guide card with steps 1·2·3 and a cursor",
      kicker: "Manual",
      title: "How to use each screen",
      text: "Follow along from creating a project to 3D measurement.",
    },
    plan: {
      alt: "The DroneSquare app icon tile next to two plan cards, Standard and Advanced",
      kicker: "Plans",
      title: "Standard · Advanced",
      text: "Compare plans that fit the size of your site.",
    },
    survey: {
      alt: "A drone flying a dotted route over an isometric site board next to a topographic map result card",
      kicker: "Drone survey service",
      title: "From capture to the platform",
      text: "Drone operation experts capture and process the data themselves.",
    },
  },
  survey: {
    eyebrow: "Drone survey & spatial data processing",
    title: "End-to-end drone solutions<br/>built by experts",
    description:
      "Drone operation experts take your requirements and deliver everything from capturing the target area to high-precision mapping, quickly and accurately.",
    heroAlt: "A white camera drone flying over a forest",
    ask: "Contact us",
    process: {
      eyebrow: "Process",
      title: "From flight approval<br/>to the platform",
    },
    results: {
      eyebrow: "Deliverables",
      title: "Deliverables from a single flight",
      lead: "Every deliverable is uploaded to the DroneSquare platform so you can check it right away in 2D and 3D.",
      tabsLabel: "Deliverable types",
      tabs: [
        {
          name: "Orthomosaic",
          note: "High-resolution map with distortion corrected",
          alt: "Deliverable: orthomosaic. The earthwork site seen obliquely from above the northeast.",
        },
        {
          name: "DSM",
          note: "Surface elevation model",
          alt: "Deliverable: DSM from the same viewpoint. Low ground is blue and high ground is red.",
        },
        {
          name: "Point Cloud",
          note: "Point data built by aligning photos",
          alt: "Deliverable: point cloud from the same viewpoint. The site appears in 3D as dense colored points.",
        },
        {
          name: "3D model",
          note: "3D model with photographic texture",
          alt: "Deliverable: 3D model from the same viewpoint. Cut slopes and access roads appear in 3D.",
        },
        {
          name: "Simplified topographic map",
          note: "1-meter contours",
          alt: "Deliverable: simplified topographic map from the same viewpoint, with 1-meter contours and 5-meter index lines.",
        },
      ],
    },
    closing: {
      eyebrow: "Platform",
      title: "Drone-based<br/>infrastructure management platform",
      more: "Learn more",
      ask: "Contact us",
    },
  },
  accurate: {
    eyebrow: "Platform",
    title: "Drone-based<br/>infrastructure management platform",
    description:
      "Adopt DroneSquare and turn spatial data into valuable business intelligence.",
    start: "Get started",
    ask: "Contact us",
    heroVideoLabel:
      "The full DroneSquare 3D inspection screen: the issue panel and toolbar on the left, and a slowly orbiting oblique view of an excavation site's 3D model made from drone photos.",
    index: {
      title: "Every site data<br/>on one screen",
      label: "Platform features",
      items: [
        {
          title: "2D · 3D · 4D",
          text: "Move between orthomosaics and 3D models, and split the screen to compare capture dates.",
        },
        {
          title: "Survey · sections · earthwork",
          text: "Draw a line to see terrain and structure sections, and measure earthwork, length, area and volume.",
        },
        {
          title: "All your data",
          text: "Overlay and cut DXF, GIS, BIM, point clouds and vectors in one 3D view.",
        },
        {
          title: "Site records · monitoring",
          text: "Leave issues, photos, videos and 360° shots at each location, and check equipment route risks.",
        },
      ],
    },
    site: {
      eyebrow: "Site records · monitoring",
      title: "Site records and equipment risks<br/>on one map",
      lead: "Leave issues, photos, videos and 360° records at each location,<brd/> and run equipment routes in advance to find where working radii overlap.",
    },
    more: {
      title: "Learn more",
      survey: {
        alt: "A camera drone flying over water",
        kicker: "Drone survey & spatial data processing",
        title: "End-to-end drone solutions built by experts",
        text: "From flight approval to the platform, handled by drone operation experts.",
      },
      plan: {
        alt: "Two plan cards, Standard and Advanced, side by side",
        kicker: "Plans",
        title: "DroneSquare service plans",
        text: "Compare the Standard and Advanced plans for the size of your site.",
      },
    },
    closing: {
      eyebrow: "Next step",
      title: "Drone survey &<br/>spatial data processing",
      more: "Learn more",
      ask: "Contact us",
    },
  },
  landing: {
    hero: {
      title: "Drone-based infrastructure management platform",
      ask: "Contact us",
      start: "Get started",
      sceneLabel:
        "A drone flies over an excavation site taking photos; the photos are stitched into one orthomosaic, and then the same place rises into a 3D model",
    },
    service: {
      eyebrow: "Drone survey & spatial data processing",
      title: "End-to-end drone solutions<br/>built by experts",
      lead: "Drone operation experts take your requirements and deliver everything<brd/> from capturing the target area to high-precision mapping, quickly and accurately.",
    },
    closing: {
      eyebrow: "DroneSquare 1:1 inquiry",
      title:
        "Smart infrastructure asset management and analysis with DroneSquare",
    },
  },
  status: {
    home: "Go to home",
    notFound: {
      title: "Page not found",
      lead: "The address may have changed, or the page no longer exists.",
    },
    prepare: {
      title: "This page is being prepared",
      lead: "We'll have it ready for you soon.",
    },
  },
  meta: {
    siteName: "DroneSquare",
    imageAlt:
      'The DroneSquare logo beside "DroneSquare" with "Drone-based infrastructure management platform" below, over an orthophoto stitched from drone photos of a construction site',
    landing: {
      title: "DroneSquare | Drone-based infrastructure management platform",
      description:
        "An infrastructure management platform for viewing, inspecting and managing drone-captured sites in 2D and 3D.",
    },
    accurate: {
      title: "Platform | DroneSquare",
      description:
        "Adopt DroneSquare and turn spatial data into valuable business intelligence.",
    },
    survey: {
      title: "Drone surveying and spatial data processing | DroneSquare",
      description:
        "Drone operation experts handle everything from flight approval to orthophotos, DSMs, 3D models and simplified topographic maps.",
    },
    plan: {
      title: "Plans | DroneSquare",
      description:
        "Compare the Standard and Advanced plans to find the right fit for your site.",
    },
    inquiry: {
      title: "1:1 inquiry | DroneSquare",
      description:
        "Ask about adopting and using DroneSquare through chat or our main phone line.",
    },
    news: {
      title: "Press | DroneSquare",
      description: "News coverage of DroneSquare.",
    },
    manual: {
      title: "Manual | DroneSquare",
      description:
        "Learn how to use each DroneSquare screen by following along with videos.",
    },
    releases: {
      title: "What's new | DroneSquare",
      description:
        "Be the first to experience the latest field technology on DroneSquare.",
    },
    privacy: {
      title: "Privacy Policy | DroneSquare",
      description:
        "What personal information DroneSquare collects, why, how long it is kept, who processes it, and your rights.",
    },
    login: {
      title: "Login | DroneSquare",
      description: "Log in to your DroneSquare account.",
    },
    signup: {
      title: "Sign Up | DroneSquare",
      description: "Create a DroneSquare account.",
    },
    changepassword: {
      title: "Change Password | DroneSquare",
      description:
        "Get a verification code at your registered email and change your password.",
    },
    notFound: {
      title: "Page not found | DroneSquare",
      description:
        "The address may have changed, or the page no longer exists.",
    },
    prepare: {
      title: "Coming soon | DroneSquare",
      description: "We'll have it ready for you soon.",
    },
    article: {
      title: "{{title}} | DroneSquare Press",
    },
  },
} as const;

export default landingPages;
